import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolePipe } from '@app/modules/pipes/role.pipe';
import { ParseDatePipe } from './parse-date.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [RolePipe, ParseDatePipe],
  exports: [RolePipe, ParseDatePipe]
})
export class PipesModule {}
